import React from 'react';
import b_ from 'b_';
import {TemplateWelcome as TemplateWelcomeProps} from 'client/common/types';

import './template-welcome.css';

const b = b_.with('template-welcome');

export default function TemplateWelcome(props: TemplateWelcomeProps) {
    const {title, text} = props;

    return (
        <div className={b()}>
            <p className={b('title')}>{title}</p>
            <p className={b('text')}>{text}</p>
        </div>
    );
}
